import config from '../config';
import { handleResponse, addTenant } from './helpers';

export const catalogService = {
    getGovernmentUnits,
    getStreets,
    getSettlements,
    getCitySettlements,
    getCounties,
    getMunicipalitiesCities
};

function getGovernmentUnits() {
    const requestOptions = { 
        method: 'GET', 
        headers: { 'Content-Type': 'application/json', ...addTenant() },
    };

    return fetch(`${config.apiUrl}/catalog/government-units`, requestOptions).then(handleResponse).then((data) => {
        return data;
    });
}

function getSettlements(governmentIdentificationNumber) {
    const requestOptions = { 
        method: 'GET', 
        headers: { 'Content-Type': 'application/json', ...addTenant() },
    };

    return fetch(`${config.apiUrl}/catalog/settlements${governmentIdentificationNumber && '?governmentIdentificationNumber=' + governmentIdentificationNumber || ''}`, requestOptions).then(handleResponse).then((data) => {
        return data;
    });
}

function getStreets(identificationNumber) {
    const requestOptions = { 
        method: 'GET', 
        headers: { 'Content-Type': 'application/json', ...addTenant() },
    };

    return fetch(`${config.apiUrl}/catalog/streets${identificationNumber && '?governmentIdentificationNumber=' + identificationNumber || ''}`, requestOptions).then(handleResponse).then((data) => {
        return data;
    });
}

function getCitySettlements(governmentIdentificationNumber) {
    const requestOptions = { 
        method: 'GET', 
        headers: { 'Content-Type': 'application/json', ...addTenant() },
    };

    return fetch(`${config.apiUrl}/catalog/settlements-city?governmentIdentificationNumber=${governmentIdentificationNumber}`, requestOptions).then(handleResponse).then((data) => {
        return data;
    });
}

function getCounties() {
    const requestOptions = { 
        method: 'GET', 
        headers: { 'Content-Type': 'application/json', ...addTenant() },
    };

    return fetch(`${config.apiUrl}/catalog/counties`, requestOptions).then(handleResponse).then((data) => {
        return data;
    });
}

function getMunicipalitiesCities(countyId) {
    const requestOptions = { 
        method: 'GET', 
        headers: { 'Content-Type': 'application/json', ...addTenant() },
    };

    return fetch(`${config.apiUrl}/catalog/municipalities-cities${countyId && '?countyId=' + countyId || ''}`, requestOptions).then(handleResponse).then((data) => {
        return data;
    });
}
